import qs from 'qs'
import { LOCAL_STORAGE_KEYS } from '@/lib/consts.ts'
import { useStorage } from '@/composables/storage'

/*
 * Detect if location should be obtained from native app
 * insted of navigator's geolocation
 */
export function detectNativeLocation () {
  let params = qs.parse(window.location.search.substring(1))
  const isNativeLocationEnabled = params.use_native_location === '1'

  isNativeLocationEnabled
    ? useStorage().setItem(LOCAL_STORAGE_KEYS.USE_NATIVE_LOCATION, true)
    : useStorage().removeItem(LOCAL_STORAGE_KEYS.USE_NATIVE_LOCATION)
}
